import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowRight, Building2, Users, Award, HardHat, Home as HomeIcon, Wrench, CheckCircle, Star, Quote } from 'lucide-react';

export const Home = () => {
  const stats = [
    { number: '20+', label: 'Années d\'expérience' },
    { number: '250+', label: 'Logements sociaux' },
    { number: '100%', label: 'Satisfaction client' },
    { number: '29', label: 'Programmes' },
  ];

  const services = [
    {
      icon: Building2,
      title: 'Promotion Immobilière',
      description: 'Développement de programmes immobiliers résidentiels et sociaux.',
    },
    {
      icon: HardHat,
      title: 'Construction BTP',
      description: 'Expertise complète dans le secteur du bâtiment et travaux publics.',
    },
    {
      icon: HomeIcon,
      title: 'Habitat Social',
      description: 'Partenaire privilégié des bailleurs sociaux pour des logements de qualité.',
    },
  ];

  const testimonials = [
    {
      name: 'Vincent P.',
      text: 'Pro Home Développement est une structure qui propose des solutions TOP. Grâce à mon investissement auprès de Pro Home Développement, j\'ai diminué mon impôt sur le revenu. Merci encore pour vos précieux conseils.',
      rating: 5,
    },
    {
      name: 'Sylvie B.',
      text: 'Une équipe Top, professionnelle et disponible.',
      rating: 5,
    },
    {
      name: 'Pascale R.',
      text: 'Merci encore pour votre disponibilité, je suis très content de la qualité de vos matériaux et des tarifs proposés.',
      rating: 5,
    },
    {
      name: 'René D.',
      text: 'J\'ai beaucoup aimé la disponibilité et l\'échange que j\'ai eu avec le directeur commercial, une personne très professionnelle et qui connaît son métier.',
      rating: 5,
    },
    {
      name: 'Marie-Claire L.',
      text: 'Un accompagnement de qualité du début à la fin du projet. L\'équipe est réactive et à l\'écoute. Je recommande vivement Pro Home Développement.',
      rating: 5,
    },
  ];

  const clients = [
    { 
      name: 'Immobilière 3F', 
      logo: 'https://customer-assets.emergentagent.com/job_business-web-creator-3/artifacts/w5z4p8ir_IMG_2419.jpeg'
    },
    { 
      name: 'Vivest', 
      logo: 'https://customer-assets.emergentagent.com/job_business-web-creator-3/artifacts/emdqj39p_IMG_2418.jpeg'
    },
    { 
      name: 'Maisons & Cités', 
      logo: 'https://customer-assets.emergentagent.com/job_business-web-creator-3/artifacts/1i7afec3_IMG_2417.jpeg'
    },
  ];

  const featuredProjects = [
    {
      name: 'Résidence Romina',
      type: '10 appartements',
      yearAcquired: '2017',
      yearCompleted: '2019',
      image: 'https://customer-assets.emergentagent.com/job_36e39742-fbf9-436c-9759-46f0576965a5/artifacts/9io6iicw_IMG_2444.jpeg',
    },
    {
      name: 'Résidence Lorenzo',
      type: '12 logements',
      yearAcquired: '2018',
      yearCompleted: '2022',
      image: 'https://customer-assets.emergentagent.com/job_36e39742-fbf9-436c-9759-46f0576965a5/artifacts/w45w3eod_IMG_2443.jpeg',
    },
    {
      name: 'Résidence Luna',
      type: '10 appartements',
      yearAcquired: '2018',
      yearCompleted: '2023',
      image: 'https://customer-assets.emergentagent.com/job_36e39742-fbf9-436c-9759-46f0576965a5/artifacts/vu9g7l06_IMG_2439.jpeg',
    },
  ];

  return (
    <div data-testid="home-page">
      {/* Hero Section */}
      <section
        data-testid="hero-section"
        className="relative min-h-screen flex items-center justify-center overflow-hidden bg-[#F4F4F5]"
      >
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-5">
          <div className="absolute inset-0" style={{ backgroundImage: 'url(https://images.pexels.com/photos/13227045/pexels-photo-13227045.jpeg?auto=compress&cs=tinysrgb&w=1920)', backgroundSize: 'cover', backgroundPosition: 'center' }}></div>
        </div>

        {/* Content */}
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32">
          <div className="max-w-3xl">
            <p className="text-[#F25F19] font-bold uppercase tracking-widest mb-4 animate-fade-in">
              PRO HOME Développement
            </p>
            <h1 className="text-4xl sm:text-5xl lg:text-7xl font-extrabold text-[#0A0A0A] uppercase tracking-tighter leading-none mb-6 animate-slide-up">
              Construire<br />
              <span className="text-[#F25F19]">L'Avenir</span><br />
              de l'Habitat
            </h1>
            <p className="text-lg md:text-xl text-[#71717A] mb-8 max-w-xl animate-fade-in" style={{ animationDelay: '0.2s' }}>
              Partenaire de confiance des bailleurs sociaux et de la promotion immobilière. 
              Excellence et engagement au service de vos projets.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 animate-fade-in" style={{ animationDelay: '0.4s' }}>
              <Link to="/projets">
                <Button
                  data-testid="hero-projects-btn"
                  className="bg-[#F25F19] hover:bg-[#CC480B] text-white font-bold uppercase tracking-wide px-8 py-6 text-base rounded-sm transition-transform hover:-translate-y-1"
                >
                  Découvrir nos projets
                  <ArrowRight className="ml-2 w-5 h-5" />
                </Button>
              </Link>
              <Link to="/contact">
                <Button
                  data-testid="hero-contact-btn"
                  variant="outline"
                  className="border-[#0A0A0A] text-[#0A0A0A] hover:bg-[#0A0A0A] hover:text-white font-bold uppercase tracking-wide px-8 py-6 text-base rounded-sm"
                >
                  Nous contacter
                </Button>
              </Link>
            </div>
          </div>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
          <div className="w-6 h-10 border-2 border-[#0A0A0A]/30 rounded-full flex justify-center">
            <div className="w-1 h-3 bg-[#0A0A0A]/30 rounded-full mt-2"></div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section data-testid="stats-section" className="bg-white py-16 border-y border-[#E4E4E7]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {stats.map((stat, index) => (
              <div key={index} className="text-center">
                <p className="stat-number">{stat.number}</p>
                <p className="text-[#71717A] mt-2">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section data-testid="services-section" className="py-20 lg:py-32 bg-[#0A0A0A]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <p className="text-[#F25F19] font-bold uppercase tracking-widest mb-4">Nos expertises</p>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white tracking-tighter">Des services sur mesure</h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div
                key={index}
                className="bg-[#18181B] p-8 rounded-sm group cursor-pointer hover:bg-[#F25F19] transition-colors duration-300"
              >
                <service.icon className="w-12 h-12 text-[#F25F19] mb-6 group-hover:text-white transition-colors" />
                <h3 className="text-xl font-bold mb-4 tracking-tight text-white">{service.title}</h3>
                <p className="text-white/60 group-hover:text-white/90 transition-colors">
                  {service.description}
                </p>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <Link to="/services">
              <Button
                data-testid="services-btn"
                variant="outline"
                className="border-white text-white hover:bg-white hover:text-[#0A0A0A] font-bold uppercase tracking-wide px-8 py-4 rounded-sm"
              >
                Tous nos services
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Featured Projects */}
      <section data-testid="projects-section" className="py-20 lg:py-32 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-16">
            <div>
              <p className="text-[#F25F19] font-bold uppercase tracking-widest mb-4">Nos réalisations</p>
              <h2 className="section-title">Projets récents</h2>
            </div>
            <Link to="/projets" className="mt-4 md:mt-0">
              <Button
                variant="link"
                className="text-[#0A0A0A] font-bold uppercase tracking-wide p-0 hover:text-[#F25F19]"
              >
                Voir tous les projets
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
            </Link>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {featuredProjects.map((project, index) => (
              <div
                key={index}
                className="project-card group overflow-hidden rounded-sm bg-white"
              >
                <div className="aspect-[4/3] overflow-hidden">
                  <img
                    src={project.image}
                    alt={project.name}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold tracking-tight mb-3 text-[#0A0A0A]">{project.name}</h3>
                  <div className="space-y-1 text-sm text-[#71717A]">
                    <p><span className="font-medium text-[#0A0A0A]">Type de bien :</span> {project.type}</p>
                    <p><span className="font-medium text-[#0A0A0A]">Date d'acquisition :</span> {project.yearAcquired}</p>
                    <p><span className="font-medium text-[#0A0A0A]">Date d'achèvement :</span> {project.yearCompleted}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Clients Trust Section */}
      <section data-testid="clients-section" className="py-20 lg:py-24 bg-[#F4F4F5]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <p className="text-[#F25F19] font-bold uppercase tracking-widest mb-4">Nos clients</p>
            <h2 className="section-title">Ils nous font confiance</h2>
            <p className="section-subtitle mt-4 max-w-2xl mx-auto">
              Les bailleurs sociaux qui acquièrent l'ensemble de nos programmes immobiliers.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            {clients.map((client, index) => (
              <div
                key={index}
                className="flex flex-col items-center justify-center p-8 bg-white rounded-sm shadow-sm hover:shadow-lg transition-shadow"
              >
                <img 
                  src={client.logo} 
                  alt={client.name}
                  className="max-h-20 w-auto object-contain mb-4"
                />
                <p className="text-sm text-[#71717A] text-center">Acheteur de l'ensemble immobilier</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section data-testid="testimonials-section" className="py-20 lg:py-32 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <p className="text-[#F25F19] font-bold uppercase tracking-widest mb-4">Témoignages</p>
            <h2 className="section-title">Ce que disent nos clients</h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <div
                key={index}
                className="bg-[#F4F4F5] p-8 rounded-sm relative"
              >
                <Quote className="w-10 h-10 text-[#F25F19] opacity-20 absolute top-6 right-6" />
                <div className="flex gap-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 fill-[#F25F19] text-[#F25F19]" />
                  ))}
                </div>
                <p className="text-[#0A0A0A] mb-6 relative z-10">
                  "{testimonial.text}"
                </p>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-[#F25F19] rounded-full flex items-center justify-center">
                    <span className="text-white font-bold text-sm">
                      {testimonial.name.charAt(0)}
                    </span>
                  </div>
                  <p className="font-bold text-[#0A0A0A]">{testimonial.name}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section data-testid="why-us-section" className="py-20 lg:py-32 bg-[#F4F4F5]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <p className="text-[#F25F19] font-bold uppercase tracking-widest mb-4">Pourquoi nous choisir</p>
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#0A0A0A] tracking-tighter mb-8">
                L'expertise au service de vos projets
              </h2>
              <div className="space-y-6">
                {[
                  'Plus de 20 ans d\'expérience dans le BTP',
                  'Partenaire privilégié des bailleurs sociaux',
                  'Garanties constructeurs et GFA',
                  'Suivi personnalisé de chaque projet',
                  'Engagement qualité et délais',
                ].map((item, index) => (
                  <div key={index} className="flex items-center gap-4">
                    <CheckCircle className="w-6 h-6 text-[#F25F19] flex-shrink-0" />
                    <p className="text-[#71717A]">{item}</p>
                  </div>
                ))}
              </div>
              <div className="mt-10">
                <Link to="/a-propos">
                  <Button
                    data-testid="about-btn"
                    className="bg-[#F25F19] hover:bg-[#CC480B] text-white font-bold uppercase tracking-wide px-8 py-4 rounded-sm"
                  >
                    En savoir plus
                    <ArrowRight className="ml-2 w-5 h-5" />
                  </Button>
                </Link>
              </div>
            </div>
            <div className="relative">
              <img
                src="https://images.pexels.com/photos/7937659/pexels-photo-7937659.jpeg?auto=compress&cs=tinysrgb&w=800"
                alt="Équipe PRO HOME"
                className="rounded-sm w-full"
              />
              <div className="absolute -bottom-6 -left-6 bg-[#0A0A0A] p-6 rounded-sm">
                <p className="text-[#F25F19] text-4xl font-bold mono">20+</p>
                <p className="text-white/80 text-sm">Années d'expérience</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section data-testid="cta-section" className="py-20 lg:py-24 bg-[#0A0A0A]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white tracking-tighter mb-6">
            Prêt à démarrer votre projet ?
          </h2>
          <p className="text-white/70 text-lg max-w-2xl mx-auto mb-10">
            Contactez notre équipe commerciale pour discuter de votre projet immobilier. 
            Devis gratuit et sans engagement.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link to="/contact">
              <Button
                data-testid="cta-contact-btn"
                className="bg-[#F25F19] hover:bg-[#CC480B] text-white font-bold uppercase tracking-wide px-8 py-6 text-base rounded-sm"
              >
                Demander un devis
              </Button>
            </Link>
            <a href="tel:0134908690">
              <Button
                variant="outline"
                className="border-white text-white hover:bg-white hover:text-[#0A0A0A] font-bold uppercase tracking-wide px-8 py-6 text-base rounded-sm"
              >
                01.34.90.86.90
              </Button>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
